import Footer from 'components/Footers/Footer'
import Navbar from 'components/Navbars/AdminNavbar'
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import BASE_URL from 'components/BaseUrl/apiConfig';
import Swal from 'sweetalert2';
import BlockUiOverlay from 'components/Expense/BlockUiOverlay';


const Users = () => {


    const history = useHistory();
    // Function to navigate to the "Add Expense Type" page

    const [loading, setLoading] = useState(false);


    useEffect(() => {
        // Check if user is not logged in (localStorage is empty)
        if (!localStorage.getItem("userData")) {
            // Redirect to the login page
            history.push("/login");
        }
    }, [history]);



    const [users, setUsers] = useState([]);

    useEffect(() => {
        setLoading(true)
        // Fetch data from the API when the component mounts
        fetch(`${BASE_URL}/api/Users/GetAllUsers`)
            .then(response => response.json())
            .then(data => { setUsers(data); setLoading(false) })
            .catch(error => { console.error('Error fetching data:', error); setLoading(false) });

    }, []);




    const navigateAddUser = () => {
        history.push('/addUsers');
    };


    const navigateEditUser = (user) => {
        // Use the history object to navigate to the "/editUsers" page with the user data
        history.push({
            pathname: `/editUsers`,
            state: { user },
        });
    };



    const viewUser = (user) => {
        // Use the history object to navigate to the "/userDetailsByAdmin" page with the user data
        history.push({
            pathname: `/viewUser`,
            state: { user },
        });
    };


    const deleteUser = (userId, userName) => {
        // Show a SweetAlert confirmation before deleting
        Swal.fire({
            title: 'Confirmation',
            text: `Are you sure want to delete ${userName}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes',
        }).then((result) => {
            if (result.isConfirmed) {
                // User clicked "Yes, delete it!" - Perform the delete API call
                fetch(`${BASE_URL}/api/Users/DeleteUser?userId=${userId}`, {
                    method: 'Post',
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            // Handle successful delete (remove the user from the state, show success message, etc.)
                            setUsers(prevUsers => prevUsers.filter(user => user.userId !== userId));
                            Swal.fire('Deleted!', 'User has been deleted successfully.', 'success');
                        } else {
                            // Handle delete failure (show error message, etc.)
                            Swal.fire('Error!', 'User deletion failed.', 'error');
                        }
                    })
                    .catch(error => console.error('Error deleting user:', error));
            }
        });
    };


    const handleVerificationButtonClick = (userId, text) => {
        Swal.fire({
            title: 'Confirmation',
            text: `Are you sure want to ${text}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes',
        }).then((result) => {
            if (result.isConfirmed) {
                // User clicked "Yes, delete it!" - Perform the delete API call
                fetch(`${BASE_URL}/api/Users/UserVerifybyAdmin?userid=${userId}`, {
                    method: 'POST',
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then(data => {
                        if (data.success) {
                            Swal.fire('Success!', `User ${text} successfully.`, 'success');
                            fetch(`${BASE_URL}/api/Users/GetAllUsers`)
                                .then(response => response.json())
                                .then(data => setUsers(data))
                                .catch(error => console.error('Error fetching data:', error));
                        } else {
                            // Handle verification failure (show error message, etc.)
                            Swal.fire('Error!', `User ${text} failed.`, 'error');
                        }
                    })
                    .catch(error => {
                        console.error(`Error ${text} user:`, error);
                        // Handle network errors or API call issues
                        Swal.fire('Error!', 'Something went wrong. Please try again.', 'error');
                    });
            }
        });
    };



    // const formatPayDate = (dateString) => {
    //     const date = new Date(dateString);
    //     const day = date.getDate().toString().padStart(2, '0');
    //     const month = (date.getMonth() + 1).toString().padStart(2, '0');
    //     const year = date.getFullYear();
    //     return ` ${day}/${month}/${year}`;
    // };


    const formatPayDate = (dateString) => {
        const date = new Date(dateString);

        const options = {
            timeZone: 'Asia/Kolkata', // Adjust the time zone according to your requirement
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        };
        return date.toLocaleString('en-IN', options);
    };


    return (
        <>
            <Navbar />
            <BlockUiOverlay visible={loading} />
            <div className="container mx-auto p-4">
                <div className="flex justify-between items-center mb-4">
                    <h1 className="text-2xl font-bold">Users</h1>
                    <button
                        onClick={navigateAddUser}
                        className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                        type="button"
                    >
                        Add new User
                    </button>
                </div>
                <div className="overflow-x-auto">
                    <table className="w-full min-w-full  ">
                        <tbody>
                            <tr className="border-b bg-lightBlue-500 text-white " >
                                <td className="cell py-2 px-4 font-bold">Full Name</td>
                                <td className="cell py-2 px-4 font-bold">User Name</td>
                                <td className="cell py-2 px-4 font-bold">Email</td>
                                <td className="cell py-2 px-4 font-bold">Last Login</td>
                                <td className="cell py-2 px-4 font-bold">Status</td>
                                <td className="cell py-2 px-4 font-bold">Actions</td>
                            </tr>
                            {users.map((user) => (
                                <tr key={user.userId} className="hover:bg-gray-100 border-b">
                                    <td className="cell py-2 px-4">{user.fullName}</td>
                                    <td className="cell py-2 px-4">{user.userName}</td>
                                    <td className="cell py-2 px-4">{user.emailId}</td>
                                    <td className="cell py-2 px-4">{formatPayDate(user.lastLogin)}</td>
                                    <td className="cell py-2 px-4">
                                        <button
                                            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs  px-2 py-1  rounded   outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => handleVerificationButtonClick(user.userId, user.isVerified === 1 ? 'Active' : 'Deactive')}
                                        >
                                            {user.isVerified === 1 ? 'Deactive' : 'Active'}
                                        </button>
                                    </td>

                                    <td className="cell py-2 px-4 flex items-center">

                                        {/* View Icon */}
                                        <img
                                            title='View'
                                            src={require("assets/img/Viewicon.png")}
                                            alt="View"
                                            className="mr-2 cursor-pointer"
                                            style={{ width: '20px' }}
                                            onClick={() => viewUser(user)}
                                        />
                                        {/* Edit Icon */}
                                        <img
                                            title='Edit'
                                            src={require("assets/img/Editicon.png")}
                                            alt="Edit"
                                            className="mr-2 cursor-pointer"
                                            style={{ width: '20px' }}
                                            onClick={() => navigateEditUser(user)}
                                        />
                                        <img
                                            title='Delete'
                                            src={require("assets/img/deleteicon.png")}
                                            alt="Delete"
                                            className="cursor-pointer"
                                            style={{ width: '20px' }}
                                            onClick={() => deleteUser(user.userId, user.userName)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Users
